export function isSentryEnabled(): boolean {
    // Browser: prefer window.env flag injected by server
    if (typeof window !== "undefined" && (window as any)?.env) {
        const flag = (window as any).env.SENTRY_ENABLED;
        if (typeof flag === "string") return flag.toLowerCase() === "true";
        // Fallback to Vite's production flag
        return (
            typeof import.meta !== "undefined" &&
            !!(import.meta as any)?.env?.PROD
        );
    }
    // Server: check explicit flag or fallback to NODE_ENV
    const envFlag = process.env.SENTRY_ENABLED;
    if (typeof envFlag === "string") return envFlag.toLowerCase() === "true";
    return process.env.NODE_ENV === "production";
}

export function getSentryDsn(): string | undefined {
    if (typeof window !== "undefined" && (window as any)?.env) {
        return (window as any).env.SENTRY_DSN;
    }
    return process.env.SENTRY_DSN;
}

export function getBrowserEnvVar(key: string): string | undefined {
    if (typeof window !== "undefined" && (window as any)?.env) {
        return (window as any).env[key];
    }
    return process.env[key];
}

export const PRODUCT_NAME = getBrowserEnvVar("PRODUCT_NAME") || "IFS Companion";
export const SUPPORT_EMAIL =
    getBrowserEnvVar("SUPPORT_EMAIL") || "hello@partscompanion.org";
export const SERVER_URL =
    getBrowserEnvVar("SERVER_URL") || "https://app.partscompanion.org";
